export const getColor = (stockType: string | null = 'AVAILABLE') => {
  switch (stockType) {
    case 'AVAILABLE':
      return 'green';
    case 'NOT_AVAILABLE':
      return 'orange';
    case 'NOT_AVAILABLE_LONGTERM':
      return 'red';
    default:
      return 'green';
  }
};
